var map = {
	"./AdaIDE.dark.png": 4446,
	"./AdaIDE.darkplus.png": 805,
	"./AdaIDE.default.png": 2392,
	"./AdaIDE.pink.png": 1194,
	"./CCmake.dark.png": 172,
	"./CCmake.darkplus.png": 8754,
	"./CCmake.default.png": 6460,
	"./CCmake.pink.png": 6658,
	"./DiffofTwoCompilers.dark.png": 9797,
	"./DiffofTwoCompilers.darkplus.png": 3434,
	"./DiffofTwoCompilers.default.png": 7156,
	"./DiffofTwoCompilers.pink.png": 4691,
	"./DiffofTwoSources.dark.png": 7056,
	"./DiffofTwoSources.darkplus.png": 4891,
	"./DiffofTwoSources.default.png": 3512,
	"./DiffofTwoSources.pink.png": 7721,
	"./JavaIDE.dark.png": 4465,
	"./JavaIDE.darkplus.png": 5334,
	"./JavaIDE.default.png": 2920,
	"./JavaIDE.pink.png": 1154,
	"./LLVMIR.dark.png": 181,
	"./LLVMIR.darkplus.png": 6874,
	"./LLVMIR.default.png": 620,
	"./LLVMIR.pink.png": 303,
	"./PascalIDE.dark.png": 8088,
	"./PascalIDE.darkplus.png": 1333,
	"./PascalIDE.default.png": 2784,
	"./PascalIDE.pink.png": 8588,
	"./Preprocessor.dark.png": 6811,
	"./Preprocessor.darkplus.png": 9562,
	"./Preprocessor.default.png": 128,
	"./Preprocessor.pink.png": 767
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7456;